import { render } from "./AdminAppLabel.vue?vue&type=template&id=436d0923"
import script from "./AdminAppLabel.vue?vue&type=script&lang=js"
export * from "./AdminAppLabel.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__